// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2YwEJ","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3sbT3"};